export default __webpack_public_path__ + "static/media/Debbie 9781408345108.0ec16fb8.jpg";